import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			width: '1em',
			height: '1em',
			fontSize: theme.spacing(2),
		},
	}),
	{ name: 'BaseIcon' },
)

export default useStyles
